<div class="container">
	<img
		src="assets/search-inactive.svg"
		*ngIf="!active"
		alt=""
	/>

	<img
		src="assets/search-active.svg"
		*ngIf="active"
		alt=""
	/>

	<input
		type="text"
		data-testid="search-input"
		(focus)="onFocus()"
		(input)="onInput()"
		[placeholder]="placeholder"
		[value]="inputStr"
		[attr.aria-label]="placeholder || ('search' | i18next) || 'search'"
		#input
	/>

	<img
		src="assets/clear.svg"
		class="clear-btn"
		data-testid="clear-btn"
		[alt]="'clear search' | i18next: { format: 'capitalize' }"
		role="button"
		tabindex="0"
		(keydown.enter)="onClearClicked()"
		(keydown.space)="onClearClicked()"
		*ngIf="displayClearBtn"
		(click)="onClearClicked()"
	/>
</div>
